import React, { Fragment, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "../../Layout/Modal";
import classes from "./wallet.module.css";

function Wallet() {
  const [enterAmount, setEnteredAmount] = useState(false);
  const [card, setCard] = useState(false);
  const navigate = useNavigate();
  const amountRef = useRef();

  const addAmountHandler = (e) => {
    e.preventDefault();
    const enteredAmount = amountRef.current.value;
    console.log(enteredAmount);
  };
  return (
    <Fragment>
      <div className={classes.container}>
        <header className={classes.header}>
          <div
            onClick={() => {
              navigate("/profile", { replace: true });
            }}
            className={classes.back}
          >
            <i class="fa-solid fa-arrow-left"></i>
          </div>
          <h1>Wallet</h1>
          <button
            onClick={() => {
              setEnteredAmount((prevState) => {
                return !prevState;
              });
            }}
          >
            Fund Wallet <i class="fa-solid fa-plus"></i>
          </button>
        </header>
        <div className={classes.balance}>
          <h1>Available Balance</h1>
          <h2>N0</h2>
        </div>
        <div className={classes.card}>
          <h1>Manage Cards</h1>
          <h2
            onClick={() => {
              setCard(true);
            }}
          >
            <i class="fa-solid fa-plus"></i>Add a new card
          </h2>
        </div>
        <hr />
        <div className={classes.transaction}>
          <h1>Transaction History</h1>
          <div className={classes.money}>
            <i class="fa-solid fa-arrow-down"></i>
            <h1>12000</h1>
            <date>today</date>
          </div>
          <div className={classes.money1}>
            <i class="fa-solid fa-arrow-up"></i>
            <h1>9600</h1>
            <date>yesterday</date>
          </div>
        </div>
      </div>
      {enterAmount && (
        <Modal>
          <div className={classes.amount}>
            <form onSubmit={addAmountHandler}>
              <label htmlFor="amount">Enter Amount</label>
              <input ref={amountRef} id="amount" type="number" />
              <div className={classes.action}>
                <button onClick={() => setEnteredAmount(false)}>Cancel</button>
                <button>Proceed</button>
              </div>
            </form>
          </div>
        </Modal>
      )}
      {card && (
        <Modal>
          <div className={classes.add}>
            <p>COMING SOON</p>
            <button
              onClick={() => {
                setCard(false);
              }}
            >
              Close
            </button>
          </div>
        </Modal>
      )}
    </Fragment>
  );
}

export default Wallet;
